export const DNF_KEYS = ['d', 'D', '/'];
export const DNS_KEYS = ['s', 'S', '*'];
